import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from '../../../theme';

function EmptyPhotosMessage() {
  return (
    <Box
      sx={{
        px: 3,
        py: 2.5,
        background: colors.grey['50'],
        borderRadius: '8px',
        textAlign: 'left',
        width: '100%',
      }}
    >
      <Typography variant="subtitle1">No treats right now, come sniff around later!</Typography>
      <Typography variant="caption" sx={{ color: 'secondary.text' }}>
        It can take a few weeks for the first photos to show up. Fur-tunately good things are on the way!
      </Typography>
    </Box>
  );
}

export default EmptyPhotosMessage;
